import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-texto-principal-planes',
  templateUrl: './texto-principal-planes.component.html',
  styleUrls: ['./texto-principal-planes.component.scss']
})
export class TextoPrincipalPlanesComponent implements OnInit {

  @Input() nombreTextoPrincipal!: string;
  @Input() textoInferior!: string;
  
  constructor() { }

  ngOnInit(): void {
  }

}
